import React,{useEffect, useState} from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailIcon from "@mui/icons-material/Email";
import Insta from "@mui/icons-material/Instagram";
import Twitter from "@mui/icons-material/Twitter";
import "../index.css";

function Footer() {
  // bg-gradient-to-r from-cyan-700 to-blue-900
  const [width,setWidth] = useState(window.innerWidth);
  useEffect(() => {
    setWidth(window.innerWidth)
  },[window.innerWidth]);
  // console.log(width);
  return (
    <footer className=" mt-10 flex flex-col justify-center p-6 md:p-16 gap-5 md:gap-10 bg-gradient-to-br from-sky-600 via-sky-700  to-sky-600">
      <div className="flex justify-center gap-4 md:gap-10 flex-wrap"> 
        <div className="rounded-full flex flex-col justify-center bg-[#141619]  p-3">
          <a href="https://github.com/Sahil-2904" className="flex flex-col justify-center">
            <GitHubIcon className="flex justify-center"  sx={{ color: "white",fontSize:width < 600 ? "25px" : "50px"}} />
          </a>
        </div>
        <div className="rounded-full flex flex-col justify-center bg-[#141619] p-3">
          <a href="https://www.linkedin.com/in/sahildhoot" className="flex flex-col justify-center">
            <LinkedInIcon className="flex justify-center"  sx={{ color: "white",fontSize:width < 600 ? "25px" : "50px" }} />
          </a>
        </div>
        <div className="bg-[#141619] p-3 rounded-full flex flex-col justify-center">
          <a href="mailto:sahildhoot.29@gmail.com" className="flex flex-col justify-center">
            <MailIcon className="flex justify-center"  sx={{ color: "white",fontSize:width < 600 ? "25px" : "50px" }} />
          </a>
        </div>
        <div className="rounded-full flex flex-col justify-center bg-[#141619] p-3">
          <a href="https://www.instagram.com/sahil_d_07/?hl=en" className="flex flex-col justify-center">
            <Insta className="flex justify-center"  sx={{ color: "white",fontSize:width < 600 ? "25px" : "50px" }} />
          </a>
        </div>
        <div className="rounded-full flex flex-col justify-center bg-[#141619] p-3">
          <a href="https://www.twitter.com/Sahil_2904" className="flex flex-col justify-center">
            <Twitter className="lex justify-center"  sx={{ color: "white",fontSize:width < 600 ? "25px" : "50px" }} />
          </a>
        </div>
      </div>
      <div className="flex justify-center">
          <p className="text-slate-300 text-xl"> © 2023 Sahil Dhoot</p>
      </div>
    </footer>
  );
}

export default Footer;
